import { NEXT_PUBLIC_INVENTORY_SYNC_TOKEN, NEXT_PUBLIC_INVENTORY_SYNC_URL } from "@/libs/constants/auth";
import { fetchUtil } from "@/libs/fetch";
import { Item } from "@/redux/slice/cart/types/Item";

const checkTatAvailabilityApi = (items: Item[], pincode: string, lat: string, lng: string, tatInput?: string) => {
  return fetchUtil({
    url: `${NEXT_PUBLIC_INVENTORY_SYNC_URL}/v3/tat`,
    method: "POST",
    body: {
      items,
      pincode,
      lat,
      lng,
      serviceableStores: tatInput,
      source: "PHARMA_FE",
    },
    useToken: true,
    ctype: "",
    token: NEXT_PUBLIC_INVENTORY_SYNC_TOKEN,
  });
};

export default checkTatAvailabilityApi;
